import { Case, CaseApiData } from './Case'

export interface ClosedCaseListData {
    sagListId: string
    page: number
    sager: CaseApiData[]
    totalSize: number
}

export class ClosedCaseList {
    caseListId = ''

    page = 0

    cases: Case[] = []

    totalSize = 0

    static build(data: ClosedCaseListData): ClosedCaseList {
        const closedCaseList = new ClosedCaseList()
        closedCaseList.caseListId = data.sagListId
        closedCaseList.page = data.page
        closedCaseList.cases =
            data.sager?.map((caseData) => Case.build(caseData)) ?? []
        closedCaseList.totalSize = data.totalSize
        return closedCaseList
    }
}
